import { useEffect } from 'react';

export default function TermsPage() {
  useEffect(() => {
    document.title = 'Terms of Service - Golden Crown Hotels';
  }, []);

  return (
    <div className="container py-5" style={{ maxWidth: '800px' }}>
      <h1 className="mb-4">Terms of Service</h1>
      <p className="text-muted mb-4">Last updated: February 18, 2026</p>

      <section className="mb-4">
        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing and using the Golden Crown Hotels Guest Experience Platform ("GCXP" or "Service"), 
          you agree to be bound by these Terms of Service. If you do not agree to these terms, 
          please do not use our Service.
        </p>
      </section>

      <section className="mb-4">
        <h2>2. Service Description</h2>
        <p>
          GCXP is a digital platform that allows hotel guests to access various hotel services including:
        </p>
        <ul>
          <li>Room service and food ordering</li>
          <li>Housekeeping requests</li>
          <li>Maintenance requests</li>
          <li>Communication with hotel staff</li>
          <li>Access to hotel guides and information</li>
        </ul>
      </section>

      <section className="mb-4">
        <h2>3. User Responsibilities</h2>
        <p>When using our Service, you agree to:</p>
        <ul>
          <li>Provide accurate information when requested</li>
          <li>Use the Service only for lawful purposes</li>
          <li>Not attempt to interfere with or disrupt the Service</li>
          <li>Keep your access credentials confidential</li>
        </ul>
      </section>

      <section className="mb-4">
        <h2>4. Guest Access</h2>
        <p>
          Access to GCXP is provided to registered hotel guests during their stay. 
          Access is granted through a secure link sent to your phone number or email. 
          Your access will be valid for the duration of your hotel stay.
        </p>
      </section>

      <section className="mb-4">
        <h2>5. Ordering and Payments</h2>
        <p>
          Orders placed through the Service are subject to availability and hotel policies. 
          Charges for services may be added to your room bill or processed according to 
          the hotel's payment policies.
        </p>
      </section>

      <section className="mb-4">
        <h2>6. Communication</h2>
        <p>
          By using our Service, you consent to receive communications from the hotel and 
          GCXP through the platform, SMS, WhatsApp, or email regarding your stay and service requests.
        </p>
      </section>

      <section className="mb-4">
        <h2>7. Limitation of Liability</h2>
        <p>
          Golden Crown Hotels and GCXP are not liable for any indirect, incidental, or 
          consequential damages arising from your use of the Service. The Service is 
          provided "as is" without warranties of any kind.
        </p>
      </section>

      <section className="mb-4">
        <h2>8. Changes to Terms</h2>
        <p>
          We may update these Terms of Service from time to time. Continued use of the 
          Service after changes constitutes acceptance of the new terms.
        </p>
      </section>

      <section className="mb-4">
        <h2>9. Contact</h2>
        <p>
          For questions about these Terms of Service, please contact us at:<br />
          Email: privacy@goldencrown.co.il
        </p>
      </section>
    </div>
  );
}
